export class ImportResult {
  public AlertMessage: string;
  public ImportResultsCanBeDownloaded: boolean;
  public AlertClass: string;
  public ImportResultsBlob: Blob;
}
